import { render, staticRenderFns } from "./aportesDescargar.vue?vue&type=template&id=55ed8c26&"
import script from "./aportesDescargar.vue?vue&type=script&lang=js&"
export * from "./aportesDescargar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports